import React, { useEffect, useMemo, useState } from "react";

const PEGA_PREFIXES = ["ENQ", "QRY", "GEM"];

function startsWithAllowedPrefix(referenceId) {
  const normalisedValue = (referenceId || "").trim().toUpperCase();
  return PEGA_PREFIXES.some((prefix) => normalisedValue.indexOf(prefix) === 0);
}

function setDocumentLoadingState(isLoading) {
  if (window.jQuery) {
    window.jQuery("html").toggleClass("loading", isLoading);
    return;
  }

  document.documentElement.classList.toggle("loading", isLoading);
}

function buildFallbackUrl(basePath, referenceId, email) {
  const redirectUrl = new URL(basePath || window.location.pathname || "/", window.location.origin);
  redirectUrl.searchParams.set("ReferenceID", referenceId || "");
  redirectUrl.searchParams.set("Email", email || "");
  return `${redirectUrl.pathname}${redirectUrl.search}`;
}

export default function TicketStatusPegaIsland({ config }) {
  const [loading, setLoading] = useState(true);
  const [responseData, setResponseData] = useState(null);

  const requestPayload = useMemo(
    () => ({
      referenceID: config.referenceId || "",
      email: config.email || "",
    }),
    [config.email, config.referenceId],
  );

  useEffect(() => {
    setDocumentLoadingState(loading);

    return () => {
      setDocumentLoadingState(false);
    };
  }, [loading]);

  useEffect(() => {
    async function loadTicketStatus() {
      if (!startsWithAllowedPrefix(requestPayload.referenceID)) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(config.checkTicketStatusUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify(requestPayload),
        });
        const body = await response.json();

        if (!body?.MPRN) {
          body.MPRN = "N/A";
        }

          if (Number(body?.ResponseCode) !== 200) {
          window.location.href = buildFallbackUrl(
            config.fallbackUrl,
            requestPayload.referenceID,
            requestPayload.email,
          );
          return;
        }

        setResponseData(body);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }

    void loadTicketStatus();
  }, [config.checkTicketStatusUrl, config.fallbackUrl, requestPayload]);

  return (
    <section id="ticketQuery" className={`ticketQuery mt-4${loading ? " loading" : ""}`}>
      {!responseData ? (
        <div className="h1 py-5">{config.loadingText}</div>
      ) : (
        <div className="response">
          <div className="text-center">
            <h2>{config.pageHeadingText}</h2>
            <h1>
              <strong>{responseData.ReferenceId}</strong>
            </h1>
            {responseData.FutureDueDate ? (
              <div className="update text-uppercase">
                <strong>
                  {config.nextUpdateDueLabel} {responseData.FutureDueDate}
                </strong>
              </div>
            ) : null}
          </div>
          <div className="details">
            <div className="row justify-content-center mb-5">
              <div className="col-md-3 d-flex justify-content-md-end">
                <div>
                  <div className="h3 text-bolder">{config.currentStatusLabel}</div>
                  <div className="info">
                    <strong>{responseData.Status}</strong>
                  </div>
                </div>
              </div>
              <div className="col-md-3 d-flex justify-content-md-center">
                <div>
                  <div className="h3 text-bolder">{config.dateCreatedLabel}</div>
                  <div className="info">
                    <strong>{responseData.CreatedDate}</strong>
                  </div>
                </div>
              </div>
              <div className="col-md-3 d-flex justify-content-md-start">
                <div>
                  <div className="h3 text-bolder">{config.lastUpdatedLabel}</div>
                  <div className="info">
                    <strong>{responseData.LastUpdated}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="yourQuery">
            <div className="row">
              <div className="col-md-6">
                <h3 className="section-title mb-0">{config.yourQueryLabel}</h3>
                <p className="text-blue">
                  {config.mprnLabel} :
                  <br />
                  <strong>{responseData.MPRN}</strong>
                </p>
                <p
                  className="text-blue"
                  dangerouslySetInnerHTML={{ __html: responseData.Description || "" }}
                />
              </div>
            </div>
          </div>
          <div className="row my-4">
            <div className="col-md-3 column mb-3 px-0">
              <a href={config.homeButtonUrl} className="btn btn-arrow-left  btn-wide btn-back">
                <span>{config.homeButtonLabel}</span>
              </a>
            </div>
            <div className="col-md-6 offset-md-3 column mb-3 px-0">
              <a href={config.checkAnotherTicketUrl} className="btn btn-wide btn-arrow-right btn-next">
                <span>{config.checkAnotherTicketLabel}</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
